module.exports = __webpack_public_path__ + "img/registration_blaupause_dark.9280bbc1.gif";